export default __webpack_public_path__ + "static/media/armchair.1597f93d.jpg";